import forEach from "lodash/forEach";
import { Link } from "react-router-dom";
import LogoImg from "../../images/logo.png";
import SmallLogoImg from "../../images/small-logo.png";
import { PAGE_DASHBOARD } from "../../pages/Core/routes";
import {
  NAV_ADM,
  NAV_AUDIT_LOGS,
  NAV_CORE_DASHBOARD,
  NAV_DOM,
  NAV_IOR,
  NAV_NOTIFICATIONS,
  NAV_ORG,
  NAV_QAM,
  NAV_RSM,
  NAV_SETTINGS,
  NAV_TRG,
  NAV_USERS_GROUPS
} from "../_auth/config";
import {
  MODULE_ADM,
  MODULE_CORE,
  MODULE_DOM,
  MODULE_IOR,
  MODULE_ORGANIZATION,
  MODULE_QAM,
  MODULE_RSM,
  MODULE_TRG
} from "../_auth/permissions/permissions";

const pushIfAllowed = (result, permission, module, navItem) => {
  if (permission.hasModule(module) && permission.canDo(navItem.gates)) {
    result.push(navItem);
  }
};

export const composeNavigationMenuItems = (permission) => {
  const result = [NAV_CORE_DASHBOARD];

  pushIfAllowed(result, permission, MODULE_ORGANIZATION, NAV_ORG);
  pushIfAllowed(result, permission, MODULE_RSM, NAV_RSM);
  pushIfAllowed(result, permission, MODULE_IOR, NAV_IOR);
  pushIfAllowed(result, permission, MODULE_DOM, NAV_DOM);
  pushIfAllowed(result, permission, MODULE_QAM, NAV_QAM);
  pushIfAllowed(result, permission, MODULE_TRG, NAV_TRG);
  pushIfAllowed(result, permission, MODULE_ADM, NAV_ADM);
  pushIfAllowed(result, permission, MODULE_CORE, NAV_USERS_GROUPS);
  pushIfAllowed(result, permission, MODULE_CORE, NAV_SETTINGS);
  pushIfAllowed(result, permission, MODULE_CORE, NAV_NOTIFICATIONS);
  pushIfAllowed(result, permission, MODULE_CORE, NAV_AUDIT_LOGS);

  return result;
};

const isActiveMenuLink = (pathname, menuItem) => {
  if (pathname === menuItem.path) {
    return true;
  }

  let result = false;

  if (menuItem.activeRoutes) {
    menuItem.activeRoutes.forEach((item) => {
      if (pathname.includes(item)) {
        result = true;
      }
    });
  }

  return result;
};

export const getSelectedMenuKey = (location, options) => {
  let selectedKey;
  let parentSelectedKey;

  forEach(options, (item) => {
    if (item.submenu) {
      forEach(item.submenu, (submenuItem) => {
        if (isActiveMenuLink(location.pathname, submenuItem)) {
          selectedKey = submenuItem.key;
          parentSelectedKey = item.key;
        }
      });
    } else if (isActiveMenuLink(location.pathname, item)) {
      selectedKey = item.key;
    }
  });

  if (location.pathname === PAGE_DASHBOARD) {
    selectedKey = "dashboard";
  }

  return parentSelectedKey ? [parentSelectedKey, selectedKey] : [selectedKey];
};

export const getCompanyLogo = (loggedUser) => {
  let logo = LogoImg;
  let smallLogo = SmallLogoImg;
  let fullLogo = LogoImg;

  if (loggedUser?.company?.files?.length > 0) {
    loggedUser.company.files.forEach((file) => {
      if (file.purpose === "logo") {
        logo = file.sizes.headerLogo.size200w;
        fullLogo = file.fullPath;
      }

      if (file.purpose === "thumbnail") {
        smallLogo = file.sizes.thumbnail.size35w;
      }
    });
  }

  return {
    logo,
    smallLogo,
    fullLogo
  };
};

export const generateNavigationMenuItems = (options, permission, t) => {
  return (options || []).map((menuItem) => {
    if (permission.canDo(menuItem.gates)) {
      if (menuItem.submenu) {
        return {
          label: (
            <>
              {t(menuItem.name)}
              {menuItem.path && <Link to={menuItem.path} />}
            </>
          ),
          children: menuItem.submenu.map((menuSubItem) => {
            if (permission.canDo(menuSubItem.gates)) {
              return {
                label: (
                  <>
                    {t(menuSubItem.name)}
                    {menuSubItem.path && <Link to={menuSubItem.path} />}
                  </>
                ),
                key: menuSubItem.key,
                icon: <i className={menuSubItem.iconClassName} />
              };
            }
            return null;
          }),
          key: menuItem.key,
          title: t(menuItem.name),
          icon: <i className={menuItem.iconClassName} />
        };
      }
      return {
        label: (
          <>
            {t(menuItem.name)}
            {menuItem.path && <Link to={menuItem.path} />}
          </>
        ),
        key: menuItem.key,
        icon: <i className={menuItem.iconClassName} />
      };
    }
    return null;
  });
};
